import { useState } from "react";
// Import components from react-bootstrap to build the modal UI.
import { Modal, Button, Form } from "react-bootstrap";

import { CheckboxAction, DeclarationModalProps } from "../../types/components.types";

const DeclarationModal: React.FC<DeclarationModalProps> = ({ isOpen, onClose, onProceed }) => {
  // Track whether the checkbox is ticked.
  const [userAgreed, setUserAgreed] = useState(false);

  // Event handler for the checkbox to update 'userAgreed' based on whether the box is checked.
  const handleCheckboxAction = (e: CheckboxAction) => {
    setUserAgreed(e.target.checked);
  };

  // Call 'onProceed' if the user has ticked the checkbox.
  const handleProceed = () => {
    if (userAgreed) {
      onProceed();
    }
  };

  // Render the modal.
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      className="loa-declaration-modal"
    >
      <Modal.Header>
        <Modal.Title>Important Notice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>A valid Letter of Authority MUST be present prior to using the service.</p>
        <p>
          <strong>Failure to provide this could lead to termination of your employment.</strong>
        </p>
        <p>If you don&apos;t have an LOA please read the below statement verbatim:</p>
        <div>
          <p className="loa-statement">
            <em>
              &quot;I need to let you know that the Green Energy Advice Bureau will access automated
              metering information from data collectors and smart meter operators for the purposes
              of bill validation and obtaining a quote.&quot;
            </em>
          </p>
        </div>

        {/* checkbox input to allow the user to confirm that they have an LOA */}
        <Form.Group className="mt-4">
          <Form.Check
            type="checkbox"
            id="loa-checkbox"
            data-testid="loa-declaration-checkbox"
            checked={userAgreed}
            onChange={handleCheckboxAction}
            label="I have a valid Letter of Authority, or have read aloud the above statement to the customer."
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} data-testid="loa-declaration-cancel">
          Cancel
        </Button>
        <Button
          onClick={handleProceed}
          disabled={!userAgreed}
          data-testid="loa-declaration-proceed"
        >
          Proceed
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeclarationModal;
